<mat-label [id]="id" class="label" #textContent>
  <ng-container *ngIf="subtitle; else content">
    <span [innerHTML]="subtitle"></span>{{separator}}
  </ng-container>

  <ng-template #content>
    <ng-content></ng-content>{{separator}}
  </ng-template>
</mat-label>
